import Doodle from '../doodle';
import { ContainerNamePrefix, OperateBoardEnum } from '../common/Constant';
import Component from '../core/Component';
import { createElement, removeFromParent } from '../utils/Dom';
import { DoodleEvent } from './EventEnum';
import log from 'loglevel';

/**
 * 封装了Doodle
 *
 * @export
 * @class DoodleView
 * @extends {Component}
 */
export default class DoodleView extends Component {
  constructor(opts = {}) {
    super();
    this._store = null;
    this._opts = opts;

    this.e = {
      [DoodleEvent.ADD]: s => {
        this._send(DoodleEvent.ADD, JSON.parse(s));
      },
      [DoodleEvent.REMOVE]: s => {
        this._send(DoodleEvent.REMOVE, JSON.parse(s));
      },
      [DoodleEvent.REMOVE_ALL]: s => {
        this._send(DoodleEvent.REMOVE_ALL, JSON.parse(s));
      },
      [DoodleEvent.MODIFY]: s => {
        this._send(DoodleEvent.MODIFY, JSON.parse(s));
      },
      [DoodleEvent.UNDO]: s => {
        this._send(DoodleEvent.UNDO, JSON.parse(s));
      },
      [DoodleEvent.REDO]: s => {
        this._send(DoodleEvent.REDO, JSON.parse(s));
      },
      [DoodleEvent.SELECTED]: s => {},
      [DoodleEvent.DESELECTED]: s => {},
      [DoodleEvent.SELECT_CHANGED]: s => {}
    };
  }

  destroy() {
    super.destroy();

    if (this.doo) {
      // 移除画板监听事件
      Object.keys(this.e).forEach(evt => {
        this.doo.off(evt, this.e[evt]);
      });

      this.doo.destroy();
      this.doo = null;
    }
    removeFromParent(this.canvas);
  }

  /**
   * 初始化涂鸦
   *
   * @memberof DoodleView
   */
  initDoodle(elId) {
    log.debug(`initDoodle, elId: ${elId}`);
    this.destroy();
    /** 真正的画板 */
    this.doo = new Doodle();
    const rnd = ~~(Math.random() * 89999) + 10000;
    const canvasId = `${ContainerNamePrefix.Canvas}-${rnd}`;
    this.canvas = this.createEl(elId, canvasId);
    this.doo.init(canvasId, this.viewOption);
    this.initEvent();
    log.debug(`initDoodle end, elId: ${elId}`);
  }

  /**
   * 用命令操作涂鸦工具
   *
   * @param {*} type
   * @param {*} args
   * @memberof ContainerMediator
   */
  operateDoodle(type, ...args) {
    if (!this.doo) {
      log.error("Doodle haven't be initialized");
      return;
    }
    log.debug(`涂鸦收到消息：${type}, 参数为：${args.join(',')}`);

    if (this.doo) {
      this.doo.deselectAll();
    }

    var editable = this.store.getKV('editable') || false;
    switch (type) {
      case OperateBoardEnum.SetGraphic:
        var id = editable ? args[0] : -1;
        this.doo.currentGraphic(id);
        break;
      case OperateBoardEnum.SetTool:
        // 3 撤销 4重做
        if (editable || args[0] === 3 || args[0] === 4) {
          this.doo.currentGraphic(-1);
          this.doo.currentTool(args[0]);
        }
        break;
      case OperateBoardEnum.SetBackgroundColor:
        this.doo.setBackgroundColor(args[0]);
        break;
      case OperateBoardEnum.DiscardActiveObject:
        this.doo.deselectAll();
        break;
      case OperateBoardEnum.Clear:
        this.doo.clear();
        break;
      case OperateBoardEnum.ClearCache:
        this.doo.clearCache();
        break;
      case OperateBoardEnum.SetOption:
        this.doo.option = args[0];
        break;
      case OperateBoardEnum.Editable:
        this.doo.mouseEnable(args[0]);
        this.store.setKV('editable', args[0]);
        break;
      case OperateBoardEnum.SetCurrentId:
        this.doo.currentId = args[0];
        break;
      case OperateBoardEnum.Trigger:
        this.doo.trigger(args[0], args[1]);
        break;
      case OperateBoardEnum.AllData:
        var allData = args[0];
        if (typeof allData === 'object') {
          allData = JSON.stringify(allData);
        }
        this.doo.setAllData(allData);
        break;
      case OperateBoardEnum.Cacheable:
        this.doo.cacheable = args[0];
        this.store.setKV('cacheable', args[0]);
        break;
      case OperateBoardEnum.SetSize:
        this.store.setKV('cw', args[0]);
        this.store.setKV('ch', args[1]);
        this.doo.setSize(args[0], args[1]);
        break;
      case OperateBoardEnum.FitToOrigin:
        this.doo.fitToOrigin(args[0], args[1]);
        break;
      case OperateBoardEnum.SetSizeByDraw:
        this.doo.setSizeByDraw(args[0], args[1]);
        break;
      case OperateBoardEnum.SetCanvasSize:
        this.doo.setCanvasSize(args[0], args[1]);
        break;
      case OperateBoardEnum.Scale:
        break;
      case OperateBoardEnum.SetControlStyle:
        this.doo.setControlOption(args[0]);
        break;
      case OperateBoardEnum.SetWatermark:
        this.doo.setWatermark();
        break;
      case OperateBoardEnum.ClearWatermark:
        this.doo.clearWatermark();
        break;
      case OperateBoardEnum.ClearData:
        this.doo.clearData();
        break;
      case OperateBoardEnum.SaveData:
        this.doo.saveData();
        break;
      case OperateBoardEnum.LoadManydrawing:
        this.doo.loadManydrawing(args[0], args[1]);
        break;
      default:
        log.warn(`Unidentified command type: ${type}`);
        break;
    }
  }

  getDoodoleCurrentId() {
    return this.doo.getCurrentGraphicId();
  }

  createEl(elId, uid) {
    let el = document.getElementById(elId);
    // 创建画布结点并添加到el下面
    let canvas = createElement(
      'canvas',
      {
        id: uid
      },
      {
        style: 'position:absolute; z-index:2;'
      }
    );
    el.appendChild(canvas);
    return canvas;
  }

  /**
   * @description 初始化涂鸦接收的消息
   * @memberof ContainerMediator
   */
  initEvent() {
    if (!this.doo) {
      log.error("Doodle haven't be initialized");
      return;
    }

    this.doo.on(DoodleEvent.ADD, this.e[DoodleEvent.ADD]);
    this.doo.on(DoodleEvent.MODIFY, this.e[DoodleEvent.MODIFY]);
    this.doo.on(DoodleEvent.REMOVE, this.e[DoodleEvent.REMOVE]);
    this.doo.on(DoodleEvent.REMOVE_ALL, this.e[DoodleEvent.REMOVE_ALL]);
    this.doo.on(DoodleEvent.UNDO, this.e[DoodleEvent.UNDO]);
    this.doo.on(DoodleEvent.REDO, this.e[DoodleEvent.REDO]);
  }

  _send(t, o) {
    this._ee.dispatch('doodle_events', {
      id: this.id,
      type: t,
      data: o,
      stamp: Date.now().toString()
    });
  }

  get viewOption() {
    return this._opts;
  }

  set option(val) {
    this.doo.option = val;
  }

  get option() {
    return this.doo.option;
  }

  get allData() {
    return this.doo.getAllData();
  }

  get currentId() {
    return this.doo.currentId;
  }

  set store(val) {
    this._store = val;
    this._ee = this._store.getKV('ee');
  }

  get store() {
    return this._store;
  }
}
